/** Public TourHQ guide profile (reviews & rating live on this page). */
export const TOURHQ_GUIDE_URL =
  process.env.REACT_APP_TOURHQ_GUIDE_URL?.trim() ||
  'https://www.tourhq.com/guide/CZ56896/zuzana-manova';
